var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 29C15.3096 29 14.75 28.4404 14.75 27.75V7.2132L7.12233 14.6453C6.62788 15.1271 5.83649 15.1168 5.35472 14.6223C4.87294 14.1279 4.88322 13.3365 5.37767 12.8547L15.1247 3.35765C15.3672 3.11956 15.6834 3.00002 16 3C16.3166 3.00002 16.6329 3.1196 16.8755 3.35776L26.6223 12.8547C27.1168 13.3365 27.1271 14.1279 26.6453 14.6223C26.1635 15.1168 25.3721 15.1271 24.8777 14.6453L17.25 7.2132V27.75C17.25 28.4404 16.6904 29 16 29Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-filled.afafa3ae.svg";
export { ForwardRef as ReactComponent };